// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const ARTICLES_TITLE = "\u010cl\u00e1nky";
export const CURRENCY_ISO = "EUR";
export const FORUM = "F\u00f3ra";
export const SEO_TITLE_STROLLERS = "Ko\u010d\u00edkop\u00e9dia - Vyh\u013ead\u00e1va\u010d a porovn\u00e1va\u010d ko\u010d\u00edkov";
export const WIKI_REVIEWS = "Centrum recenzi\u00ed";
